
<div class="container-fluid ">
    <div class="row no-gutter">
        <div class="col-md-6 col-sm-12 customimg" >
        </div>

        <div class="col-md-6 col-sm-12 custologin " >
            <div class="centerForm center">
                <img 
                src="assets/images/login/logo-bantrab-538x124.png" 
                class="mx-auto d-block custombantrab mt-5 mb-4" 
                width="200" 
                alt="Logo Bantrab"
                />
                <div class="col-md-8 offset-md-2 ">
                    <form class="formIngreso text-center mb-4">
                        <h1 class="h3 mb-3 font-weight-normal">Ingresar</h1>
                        <label>Nombre de Usuario:</label>
                        <input type="text" 
                        id="codigo" 
                        class="form-control mb-2" 
                        [(ngModel)]="user" 
                        name="user" required autofocus>
                        <label>Contraseña:</label>
                        <input 
                        type="password" 
                        id="codigo" 
                        class="form-control" 
                        [(ngModel)]="password" 
                        name="password"  
                        required autofocus>
                        <button *ngIf="!loading" class="btn btn-lg btn-primary btn-block" type="submit" (click)='login()'>Ingresar</button>
                        <!-- routerLink="/dashboardkpi"  -->
                        <div  *ngIf="loading" class="loading"><img src="assets/images/login/loader.gif" alt="loading" /><br/>Un momento, por favor...</div>
                        <p  *ngIf="mensajeError" style="color: rgb(189, 33, 33);">El nombre de usuario o contraseña es incorrecto </p>
                    </form>
                </div>
                <img 
                    src="assets/images/login/logo-acierto-267x75.png" 
                    class="mx-auto d-block customacierto"
                    width="150" 
                    alt="lo acierto"
                />   
            </div>
        </div>
    </div>
</div>